import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Box } from '@ktag/styleguide/dist/react';

import { createPortal } from 'react-dom';
import useDisplaySize from '../../useDisplaySize';

export const INFO_BOX_ANCHOR_ID = 'info-box-anchor';

interface Props extends PropsWithChildren {
  heading: string;
  onClose: () => void;
}

const InfoBox = ({ children, onClose, heading }: Props) => {
  const { isSmallScreen } = useDisplaySize();

  const component: React.ReactNode = (
    <div
      className={classNames('notifications', {
        'notifications--small': isSmallScreen,
      })}
    >
      <Box onClose={onClose} heading={heading} additionalClassNames="notification">
        {children}
      </Box>
    </div>
  );

  const anchor = document.getElementById(INFO_BOX_ANCHOR_ID);

  if (!anchor) {
    return component;
  }

  return createPortal(component, anchor);
};

export default InfoBox;
